module.exports = "https://websites.getjusto.com/_next/static/images/addToGoogleWallet-c958c9225bafc9ceade12f62c0da1388.svg";